export default __webpack_public_path__ + "static/media/BAR.c5b5e01a.svg";